import { useState, useCallback, useEffect } from "react";
import "./header.css";
import { Dropdown } from "react-bootstrap";
import { NavLink, useHistory } from "react-router-dom";
import AuthService from "../../services/auth.service";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";

const Header = () => {
	const { user } = useContext(AuthContext);
	const history = useHistory();
	const [showInitiator, setShowInitiator] = useState(false);
	const [showReviewer, setShowReviewer] = useState(false);
	const [showApprover, setShowApprover] = useState(false);
	const [showAdmin, setShowAdmin] = useState(false);

	const logout = useCallback( () => {
		AuthService.logOut(history);
	}, [history]);

	useEffect(() => {
		if (user) {
			setShowReviewer(user.roles.includes("ROLE_REVIEWER"));
			setShowInitiator(user.roles.includes("ROLE_INITIATOR"));
			setShowApprover(user.roles.includes("ROLE_APPROVER"));
			setShowAdmin(user.roles.includes("ROLE_ADMIN"));
		} else {
			setShowReviewer(false);
			setShowInitiator(false);
			setShowApprover(false);
			setShowAdmin(false);
			history.replace("/");
			window.location.reload();
		}
	}, [user, history]);

	return (
		<div className="page-header">
			<div className="page-header__left">UBEC WORKFLOW DESK</div>
			<ul className="page-header__right page-header__list">
				{showInitiator && (
					<li className="page-header__list-item nav__item">
						<NavLink
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="nav__anchors"
							to={"/initiator/desk"}
						>
							DESK
						</NavLink>
					</li>
				)}

				{showReviewer && (
					<li className="page-header__list-item nav__item">
						<NavLink
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="nav__anchors"
							to={"/reviewer/desk"}
						>
							DESK
						</NavLink>
					</li>
				)}

				{showApprover && (
					<li className="page-header__list-item nav__item">
						<NavLink
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="nav__anchors"
							to={"/approval/desk"}
						>
							DESK
						</NavLink>
					</li>
				)}

				{showAdmin && (
					<li className="page-header__list-item nav__item">
						<NavLink
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="nav__anchors"
							to={"/admin/users"}
						>
							ADMIN
						</NavLink>
					</li>
				)}

				<li className="page-header__list-item nav__item">
					<NavLink
						style={(isActive) => ({
							opacity: isActive ? "1" : "0.6",
						})}
						className="nav__anchors"
						to={"/board/projects"}
					>
						PROJECT
					</NavLink>
				</li>

				<li className="page-header__list-item nav__item">
					<NavLink
						style={(isActive) => ({
							opacity: isActive ? "1" : "0.6",
						})}
						className="nav__anchors"
						to={"/expenditure"}
					>
						EXPENDITURE FLOW
					</NavLink>
				</li>
				<li className="page-header__list-item nav__item">
					<NavLink
						style={(isActive) => ({
							opacity: isActive ? "1" : "0.6",
						})}
						className="nav__anchors"
						to={"/messenger"}
					>
						CHAT BOX
					</NavLink>
				</li>
				<li className="page-header__list-item">
					<Dropdown className="page-header__list-item">
						<Dropdown.Toggle id="dropdown-basic">{user.email}</Dropdown.Toggle>
						<Dropdown.Menu className="header-panel">
							<div className="header-panel__list">
								<NavLink
									style={(isActive) => ({
										opacity: isActive ? "1" : "0.75",
									})}
									to={
										showInitiator
											? "/initiator/profile"
											: showReviewer
											? "/reviewer/profile"
											: showApprover
											? "/approver/profile"
											: showAdmin
											? "/admin/profile"
											: "/user/profile"
									}
									className="panel__list-item"
								>
									My Portfolio
								</NavLink>
							</div>
							<div className="header-panel__list">
								<NavLink
									style={(isActive) => ({
										opacity: isActive ? "1" : "0.75",
									})}
									to={"/staff-database"}
									className="panel__list-item"
								>
									Staff Database
								</NavLink>
							</div>
							<div className="header-panel__list">
								<NavLink
									style={(isActive) => ({
										opacity: isActive ? "1" : "0.75",
									})}
									to={"/settings"}
									className="panel__list-item"
								>
									Settings
								</NavLink>
							</div>
							<div className="header-panel__list" onClick={logout}>
								<NavLink
									style={{
										opacity: "0.8",
									}}
									to={"/"}
									className="panel__list-item"
								>
									Logout
								</NavLink>
							</div>
						</Dropdown.Menu>
					</Dropdown>
				</li>
			</ul>
		</div>
	);
};

export default Header;
